export default [
  {
    leistungstext: "Fremde private, ehrenamtliche und berufliche Schlüssel",
    infoText:
      "Wir ersetzen im Rahmen der gesetzlichen Haftpflichtansprüche auch die Auswechslung von Schlössern und Schließanlagen bei privat, beruflich und ehrenamtlich anvertrauten Schlüsseln entsprechend der angegebenen Summen.",
    leistungen: ["20.000 €", "100.000 €", "Ja"],
  },
  {
    leistungstext: "Schäden durch im europäischen Ausland gemieteten Kfz (Mallorcadeckung)",
    infoText:
      "Wir bieten ergänzenden Versicherungsschutz auch für Kfz-Haftpflichtschäden bei Mietwägen innerhalb Europas.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Gebrauch von Elektrofahrrädern",
    infoText:
      "Wir versichern die Haftpflicht aus dem Besitz und Gebrauch von Elektrofahrrädern genauso wie die von Fahrrädern.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Tägliches Kündigungsrecht",
    infoText: "",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Versicherungspflichtige motorisierte Flugmodelle (z. B. Drohnen und Quadrokopter)",
    infoText: "Die Haftpflicht für Flugmodelle ist bis 250 g oder 5 kg mitversichert.",
    leistungen: ["bis 250 g", "bis 250 g", "bis 5 kg"],
  },
  {
    leistungstext: "Forderungsausfall-Deckung",
    infoText:
      "Sind Sie selbst Geschädigter und der Schadenverursacher kann den Schaden nicht begleichen, leisten wir unter bestimmten Voraussetzungen für Ihren Forderungsausfall.",
    leistungen: ["ab 5.000 € Mindestschadenhöhe", "ab 2.000 € Mindestschadenhöhe", "Ja"],
  },
  {
    leistungstext: "Nicht deliktfähige Kinder und Personen",
    infoText:
      "Auch wenn nicht deliktfähige Kinder und Personen für Schäden nicht haftbar gemacht werden können, leisten wir Schadenersatz entsprechend der angegebenen Summen.",
    leistungen: ["Nein", "100.000 €", "Ja"],
  },
  {
    leistungstext: "Nebentätigkeit bis Jahresumsatz von",
    infoText:
      "Haftpflichtansprüche aus der Ausübung einer beruflichen Nebentätigkeit sind im Rahmen der angegebenen Summe mit abgesichert.",
    leistungen: ["Nein", "Nein", "25.000 €"],
  },
  {
    leistungstext: "Be- und Entladeschäden",
    infoText:
      "Wir ersetzen Schäden, die Dritten entstehen durch das Be- oder Entladen des selbst gebrauchten Kraftfahrzeuges oder Kraftfahrtzeug-Anhängers.",
    leistungen: ["Nein", "Nein", "5.000 €"],
  },
  {
    leistungstext: "Elektronischer Datenaustausch/Internetnutzung",
    infoText:
      "Wir versichern die Haftpflicht aus dem Austausch, der Übermittlung und der Bereitstellung elektronischer Daten für bestimmte Schäden.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "E-Ladestation/Wallbox",
    infoText:
      "Wir versichern die Haftpflicht als Inhaber und Betreiber von Elektroladestationen/Wallboxen, sofern diese nicht gewerblich genutzt werden.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Schadenübernahme bei unklaren Zuständigkeiten wegen eines Versicherungswechsels",
    infoText: "",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Vorübergehend im Haushalt eingegliederte Personen (z. B. Au-pair, Austausch)",
    infoText:
      "Haftpflichtansprüche Dritter gegen vorübergehend in der Familie lebende Personen z. B. Au-pair sind mit abgesichert, wenn diese unverheiratet sind.",
    leistungen: ["1 Jahr", "2 Jahre", "2 Jahre"],
  },
];
